import { render } from "./BlogsBlock.vue?vue&type=template&id=25d9e9d4"
import script from "./BlogsBlock.vue?vue&type=script&lang=js"
export * from "./BlogsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/Users/santoshmaharjan/Documents/htdocs/helmetsnepal-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__